export default {"src":"/_next/static/media/goat-spins-45-free-spins-easy-signup.46bc5411.svg","height":175,"width":632,"blurWidth":0,"blurHeight":0};